



















































































import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseCircleIcon from '@shared/components/@atoms/BaseCircleIcon/BaseCircleIcon.vue';
import BaseIcon from '@shared/components/@atoms/BaseIcon/BaseIcon.vue';
import BaseImage from '@shared/components/@atoms/BaseImage/BaseImage.vue';
import BaseLink from '@shared/components/@atoms/BaseLink/BaseLink.vue';
import BasePrice from '@shared/components/@atoms/BasePrice/BasePrice.vue';
import BaseProperty from '@shared/components/@atoms/BaseProperty/BaseProperty.vue';
import BaseQuantitySelector from '@shared/components/@atoms/BaseQuantitySelector/BaseQuantitySelector.vue';
export default defineComponent({
  name: 'BaseCollectedProduct',
  components: {
    BaseButton,
    BaseIcon,
    BaseImage,
    BaseCircleIcon,
    BasePrice,
    BaseQuantitySelector,
    BaseLink,
    BaseProperty,
  },
  model: {
    prop: 'qty',
  },
  props: {
    image: {
      type: String,
      default: '',
    },
    imageWidth: {
      type: [Number, String],
      default: 140,
    },
    imageHeight: {
      type: [Number, String],
      default: 200,
    },
    title: {
      type: String,
      default: '',
    },
    regularPrice: {
      type: [Number, String],
      default: null,
    },
    specialPrice: {
      type: [Number, String],
      default: null,
    },
    qty: {
      type: [Number, String],
      default: 1,
    },
    minQty: {
      type: Number,
      default: null,
    },
    maxQty: {
      type: Number,
      default: null,
    },
    link: {
      type: [String, Object],
      default: null,
    },
    hasRemove: {
      type: Boolean,
      default: true,
    },
    hasMoreActions: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    componentIs(): any {
      return this.link ? 'BaseLink' : 'div';
    },
    quantity(): any {
      // @ts-ignore migrated from ui-library
      return typeof this.qty === 'string' ? Number(this.qty) : this.qty;
    },
  },
  methods: {
    removeHandler() {
      this.$emit('click:remove');
    },
    actionsHandler() {
      this.$emit('click:actions');
    },
  },
});
